import { useEffect, useState } from 'react';
import { css, cx, etiColors, mediaQueries } from '@eti/styles';
import { DangerousHtmlContent } from '@eti/components';
import ProductIcon from './ProductIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const headerWrapperStyles = image => css`
  align-items: center;
  background: ${etiColors.grayScale[2]} url('${image}') no-repeat center;
  background-size: cover;
  border-top-left-radius: 0.1875rem;
  border-top-right-radius: 0.1875rem;
  display: flex;
  justify-content: center;
  min-height: 160px;
  padding: 10px;
  position: relative;
  width: 100%;
  word-break: break-word;

  &::before {
    background-color: rgb(0 0 0 / 50%);
    border-top-left-radius: 0.1875rem;
    border-top-right-radius: 0.1875rem;
    content: '';
    display: block;
    inset: 0;
    position: absolute;
  }

  @media ${mediaQueries.large.up} {
    justify-content: flex-start;
    min-height: 200px;
    padding: 20px;

    &::before {
      background-color: transparent;
      background-image: linear-gradient(270deg, rgb(0 0 0 / 0%), rgb(0 0 0 / 70%));
    }
  }
`;
const contentStyles = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;

  @media ${mediaQueries.large.up} {
    flex-direction: row;
  }
`;
const iconStyles = css`
  height: 50px;
  margin-bottom: 10px;
  width: 50px;

  @media ${mediaQueries.large.up} {
    height: 64px;
    margin-bottom: 0;
    margin-right: 20px;
    min-width: 64px;
    width: 64px;

    [dir='rtl'] & {
      margin-left: 20px;
      margin-right: 0;
    }
  }
`;
const titleStyles = css`
  color: #fff;
  font-size: 1.25rem;
  text-align: center;
  text-shadow: 0 0 5px rgb(0 0 0 / 80%);

  @media ${mediaQueries.large.up} {
    font-size: 1.5rem;
    text-align: left;
  }
`;
const fetchProductImage = async productName => {
  if (productName) {
    const src = await import(`@eti/assets/images/modal/${productName}@2x.jpg`);
    return src.default;
  }
  return null;
};
const ProductModalHeader = _ref => {
  let {
    className,
    productName,
    productTitle
  } = _ref;
  const [image, setImage] = useState(null);
  useEffect(() => {
    let isMounted = true;
    const loadProductImage = async () => {
      try {
        const productImage = await fetchProductImage(productName);
        if (isMounted) {
          setImage(productImage);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Warning: Error loading image for product modal for ’${productName}’ product. Error: ${error}`);
      }
    };
    loadProductImage();
    return () => {
      isMounted = false;
    };
  }, [productName]);
  return /*#__PURE__*/_jsx("div", {
    className: cx(headerWrapperStyles(image), className),
    children: /*#__PURE__*/_jsxs("div", {
      className: contentStyles,
      children: [/*#__PURE__*/_jsx(ProductIcon, {
        className: iconStyles,
        id: productName
      }), /*#__PURE__*/_jsx(DangerousHtmlContent, {
        className: titleStyles,
        component: "h3",
        content: productTitle
      })]
    })
  });
};
export default ProductModalHeader;